var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8466 18.2788C35.6703 18.2788 35.5819 18.1991 35.5819 18.04C35.5819 17.8813 35.6703 17.8011 35.8466 17.8011C36.0222 17.8011 36.1105 17.8816 36.1105 18.04C36.1105 18.1991 35.934 18.2788 35.8466 18.2788ZM35.8466 16.2916C34.7897 16.2916 33.9082 17.0861 33.9082 18.04C33.9082 18.9936 34.7897 19.7881 35.8466 19.7881C36.9037 19.7881 37.7842 18.9936 37.7842 18.04C37.7842 17.0861 36.9037 16.2916 35.8466 16.2916Z",
    fill: "url(#paint0_linear_486_2093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6173 18.2788C31.4418 18.2788 31.3534 18.1991 31.3534 18.04C31.3536 17.8813 31.4418 17.8011 31.6173 17.8011C31.7939 17.8011 31.882 17.8816 31.882 18.04C31.882 18.1991 31.7055 18.2788 31.6173 18.2788ZM31.6173 16.2916C30.5602 16.2916 29.6797 17.0861 29.6797 18.04C29.6797 18.9936 30.5602 19.7881 31.6173 19.7881C32.6744 19.7881 33.5547 18.9936 33.5547 18.04C33.555 17.0861 32.6742 16.2916 31.6173 16.2916Z",
    fill: "url(#paint1_linear_486_2093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8466 25.9071C35.6703 25.9068 35.5819 25.8282 35.5819 25.6689C35.5819 25.5105 35.6703 25.431 35.8466 25.431C36.0222 25.431 36.1105 25.5105 36.1105 25.6689C36.1105 25.8282 35.934 25.9071 35.8466 25.9071ZM35.8466 23.9205C34.7897 23.9205 33.9082 24.7151 33.9082 25.6689C33.9082 26.6227 34.7897 27.4179 35.8466 27.4179C36.9037 27.4179 37.7842 26.6227 37.7842 25.6689C37.7842 24.7151 36.9037 23.9208 35.8466 23.9205Z",
    fill: "url(#paint2_linear_486_2093)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6173 25.9071C31.4418 25.9068 31.3534 25.8282 31.3534 25.6689C31.3536 25.5105 31.4418 25.431 31.6173 25.431C31.7939 25.431 31.882 25.5105 31.882 25.6689C31.882 25.8282 31.7055 25.9071 31.6173 25.9071ZM31.6173 23.9205C30.5602 23.9205 29.6797 24.7151 29.6797 25.6689C29.6797 26.6227 30.5602 27.4179 31.6173 27.4179C32.6744 27.4179 33.5547 26.6227 33.5547 25.6689C33.555 24.7151 32.6742 23.9208 31.6173 23.9205Z",
    fill: "url(#paint3_linear_486_2093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5819 33.2982C35.5819 33.1388 35.6703 33.06 35.8466 33.06C36.0222 33.06 36.1105 33.1388 36.1105 33.2982C36.1105 33.4572 36.0222 33.5361 35.8466 33.5361C35.6703 33.5361 35.5819 33.3777 35.5819 33.2982ZM37.7842 33.2982C37.7842 32.3443 36.9037 31.5498 35.8466 31.5498C34.7897 31.5498 33.9082 32.3443 33.9082 33.2982C33.9082 34.2511 34.7897 35.0463 35.8466 35.0463C36.9037 35.0463 37.7842 34.2511 37.7842 33.2982Z",
    fill: "url(#paint4_linear_486_2093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6173 33.5361C31.4418 33.5361 31.3534 33.4572 31.3534 33.2982C31.3536 33.1388 31.4418 33.06 31.6173 33.06C31.7939 33.06 31.882 33.1388 31.882 33.2982C31.882 33.4572 31.7055 33.5361 31.6173 33.5361ZM31.6173 31.5498C30.5602 31.5498 29.6797 32.3443 29.6797 33.2982C29.6797 34.2511 30.5602 35.0463 31.6173 35.0463C32.6744 35.0463 33.5547 34.2511 33.5547 33.2982C33.555 32.3443 32.6742 31.5498 31.6173 31.5498Z",
    fill: "url(#paint5_linear_486_2093)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.837 46.0128C24.0441 46.0128 23.4277 45.4571 23.4277 44.7415C23.4277 44.0265 24.0441 43.4699 24.837 43.4699C25.6294 43.4699 26.2459 44.0265 26.2459 44.7415C26.2459 45.4571 25.6291 46.0128 24.837 46.0128ZM13.8277 36.0797C12.0664 36.0797 10.7451 34.8075 10.7451 33.2184C10.7451 31.6287 12.1543 30.3581 13.8277 30.3581H35.7581C37.5192 30.3581 38.84 31.6287 38.84 33.2184C38.84 34.8075 37.5192 36.0797 35.8462 36.0797H13.8277ZM8.71926 26.8607C5.19659 26.7023 2.37791 24.0792 2.37791 20.9011C2.37791 18.1194 4.57977 15.6563 7.57451 15.0997C8.10293 15.0202 8.45529 14.5434 8.45529 14.1459C8.27923 10.1726 12.6827 6.99387 17.3509 8.4245C17.4388 8.42427 17.5267 8.50313 17.6148 8.50313C17.6148 8.50313 19.1119 8.66311 19.3764 10.5699C19.4643 11.1264 20.0811 11.444 20.6091 11.3644C21.2259 11.2855 21.5783 10.7292 21.4899 10.2515C21.1377 8.42426 20.0811 7.39114 19.024 6.91411C20.4335 4.05374 23.6038 2.14629 27.1265 2.14629C31.7065 2.14629 35.3178 5.08618 35.8462 8.90038C34.1726 9.05969 32.587 9.5365 31.1781 10.3319C30.6496 10.6494 30.4738 11.2053 30.8259 11.6828C31.1781 12.1589 31.7946 12.3182 32.3233 12.0005C33.6441 11.2855 35.2297 10.8876 36.8152 10.8876H36.9033H36.9907C41.7473 10.8876 45.7986 14.6229 45.7986 19.0732C45.7986 22.0929 43.8603 24.954 41.0421 26.3846C41.2186 24.7151 40.4255 23.1263 39.0165 22.0929C40.2499 21.2186 41.1305 19.788 41.1305 18.2787C41.1305 15.6563 38.7526 13.4302 35.8462 13.4302H13.8277C10.9211 13.4302 8.5432 15.5765 8.5432 18.2787C8.5432 19.788 9.33609 21.2186 10.6572 22.0929C8.89557 23.0465 8.19084 25.0328 8.71926 26.8607ZM38.9281 25.6689C38.9281 26.2255 38.7526 26.7023 38.4888 27.1791C38.3123 27.2579 38.2241 27.418 38.136 27.5764C37.6073 28.1329 36.7268 28.4506 35.8462 28.4506H13.8277C12.0664 28.4506 10.7451 27.2579 10.7451 25.6689C10.7451 24.0792 12.1543 22.8874 13.8277 22.8874H35.7581C37.5192 22.8874 38.9281 24.0792 38.9281 25.6689ZM35.8462 20.9011H13.8277C12.0664 20.9011 10.7451 19.6296 10.7451 18.0399C10.7451 16.4499 12.1543 15.1786 13.8277 15.1786H35.7581C37.5192 15.1786 38.84 16.4499 38.84 18.0399C38.9281 19.6296 37.5192 20.9011 35.8462 20.9011ZM46.8548 43.7081H28.2717C27.9189 42.6754 27.0391 41.8809 25.8938 41.5634V38.066H35.7581C38.6644 38.066 41.0421 35.9204 41.0421 33.2184C41.0421 31.7089 40.2499 30.2777 38.9281 29.4043C39.1928 29.2452 39.4568 29.0063 39.7213 28.7681C44.4771 27.5764 47.9118 23.4438 47.9118 18.835C47.9118 13.5902 43.5081 9.21877 37.9602 8.74197C37.4318 3.73599 32.7636 1.47176e-08 27.0391 1.47176e-08C22.3706 -0.000223417 18.4956 2.54356 16.8222 6.11958C11.5379 5.08621 6.51741 8.50313 6.07739 13.2718C2.46632 14.3052 0 17.4038 0 20.8214C0 25.1921 3.96343 28.7681 8.80766 28.7681C9.16002 28.7681 9.33608 28.7682 9.60005 28.6895C9.86426 28.9275 10.1285 29.1656 10.3927 29.3238C9.16002 30.1988 8.27899 31.6287 8.27899 33.1389C8.27924 35.7613 10.6571 37.9871 13.5635 37.9871H23.4277V41.483C22.283 41.8013 21.402 42.5958 21.0498 43.6292H2.81868C2.20186 43.6292 1.67368 44.1054 1.67368 44.6617C1.67368 45.2183 2.20186 45.6951 2.81868 45.6951H21.4022C21.8422 47.0462 23.2514 48 24.837 48C26.4225 48 27.8315 47.0462 28.2717 45.6951H46.8548C47.4716 45.6951 48 45.2183 48 44.6617C48 44.1858 47.4716 43.7081 46.8548 43.7081Z",
    fill: "url(#paint6_linear_486_2093)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1562 17.3251H25.2792V18.8352H12.1562V17.3251Z",
    fill: "url(#paint7_linear_486_2093)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1562 24.8743H25.2792V26.4642H12.1562V24.8743Z",
    fill: "url(#paint8_linear_486_2093)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1562 32.5038H25.2792V34.0929H12.1562V32.5038Z",
    fill: "url(#paint9_linear_486_2093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_2093",
    x1: 35.8462,
    y1: 16.2916,
    x2: 35.8462,
    y2: 19.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_2093",
    x1: 31.6172,
    y1: 16.2916,
    x2: 31.6172,
    y2: 19.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_2093",
    x1: 35.8462,
    y1: 23.9205,
    x2: 35.8462,
    y2: 27.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_2093",
    x1: 31.6172,
    y1: 23.9205,
    x2: 31.6172,
    y2: 27.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_2093",
    x1: 35.8462,
    y1: 31.5498,
    x2: 35.8462,
    y2: 35.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_2093",
    x1: 31.6172,
    y1: 31.5498,
    x2: 31.6172,
    y2: 35.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_2093",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_2093",
    x1: 18.7177,
    y1: 17.3251,
    x2: 18.7177,
    y2: 18.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_2093",
    x1: 18.7177,
    y1: 24.8743,
    x2: 18.7177,
    y2: 26.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_2093",
    x1: 18.7177,
    y1: 32.5038,
    x2: 18.7177,
    y2: 34.0929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.0a58aa191343787753a6478b59ddec11.svg";
export { ForwardRef as ReactComponent };